import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ILayout2_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ILayout2_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp984720Visible: "visible" | "hidden";
  isComp413023Visible: "visible" | "hidden";
  isComp808272Visible: "visible" | "hidden";
  isComp809899Visible: "visible" | "hidden";
  isComp299222Visible: "visible" | "hidden";
  isComp618118Visible: "visible" | "hidden";
  isComp422272Visible: "visible" | "hidden";
  isComp46880Visible: "visible" | "hidden";
  isComp994953Visible: "visible" | "hidden";
  isComplayout2_777738AuthorizationVisible: "visible" | "hidden";
}

export class Layout2_ScreenBase extends React.PureComponent<
  ILayout2_ScreenProps,
  any
> {
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "04e21c3a-025f-4f6e-82ae-a9c0776c1b0a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 78803, PropertyName: "label", Value: "Anasayfa" },
        { Id: 984720, PropertyName: "label", Value: "Müşteri" },
        { Id: 413023, PropertyName: "label", Value: "İstasyonlar" },
        { Id: 808272, PropertyName: "label", Value: "Ürünler" },
        { Id: 809899, PropertyName: "label", Value: "KLT Kutular" },
        { Id: 299222, PropertyName: "label", Value: "Siparişler" },
        { Id: 618118, PropertyName: "label", Value: "Kullanıcılar" },
        { Id: 422272, PropertyName: "label", Value: "Kullanıcı Grupları" },
        { Id: 46880, PropertyName: "label", Value: "Teslim - Tesellüm" },
        { Id: 777738, PropertyName: "label", Value: "Mail Grubu" },
        { Id: 994953, PropertyName: "label", Value: "Query" },
        { Id: 59156, PropertyName: "value", Value: "ÇIKIŞ" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetUserWithGroupDetails: [],
      Logout: false,
      goToSignInActivity: "",
      NAVIGATE: "",
      isComp984720Visible: "hidden",
      isComp413023Visible: "hidden",
      isComp808272Visible: "hidden",
      isComp809899Visible: "hidden",
      isComp299222Visible: "hidden",
      isComp618118Visible: "hidden",
      isComp422272Visible: "hidden",
      isComp46880Visible: "hidden",
      isComp994953Visible: "hidden",
      isComplayout2_777738AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("layout2", "");
      return;
    }

    if (true) {
      await this.Layout2PageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComplayout2_777738AuthorizationVisible",
      ["9ce12e34-238d-bdef-fd1a-52c0cedd530c", "manager"]
    );

    KuikaAppManager.calculateAndSetBodyHeight("layout2", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("layout2", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.Layout2PageInit();
    }

    if (
      prevProps.isMasterPageInitLoaded !== this.props.isMasterPageInitLoaded &&
      this.props.isMasterPageInitLoaded === true
    ) {
    }
    if (
      prevProps.shouldTriggerPageInit !== this.props.shouldTriggerPageInit &&
      this.props.shouldTriggerPageInit === true
    ) {
      this.Layout2PageInit();
      this.props.setShouldTriggerPageInit(false);
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      layout2_328432_value: { collapsed: false },
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  Layout2PageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Layout2/Layout2PageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    formVars.layout2_515602_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].fullName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].fullName
        : null
    );
    stateVars.isComp984720Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp413023Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp808272Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].productsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].productsView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp809899Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp299222Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp618118Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp422272Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].userGroupView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].userGroupView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Layout2PageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Layout2PageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.layout2_515602_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].fullName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].fullName
        : null
    );

    stateVars.isComp984720Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp413023Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp808272Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].productsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].productsView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp809899Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp299222Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp618118Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp422272Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].userGroupView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].userGroupView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp994953Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.getMyUsername(),
        ReactSystemFunctions.convertToTypeByName(
          "omer.kavas@normdigital.com",
          "string"
        )
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.props.setMasterPageInitLoaded(true);
    return isErrorOccurred;
  };

  Layout2Component_220907_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_78803_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "Anasayfa",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_984720_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "Customer_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_413023_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "Station_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_808272_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "Product_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_809899_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "STDBoxes_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_299222_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "Orders_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_618118_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "STDUsers_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_422272_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "UserGroup_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_46880_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "EslestirmeTeslimTesellum",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_777738_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "MailGroups",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_994953_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Layout2",
      "SQLQueryScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Layout2Component_59156_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , , , , , , , , ,] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["Layout2"] ?? false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.Layout2PageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.Layout2PageInit();
    }
    this.props?.callCallbackFunction?.(diId, true);
  }
}
